<template>
  <div id="app"> 

    <!-- <keep-alive>    	 -->
    	 <!-- <router-view/> -->
    <!-- </keep-alive> -->


      <router-view></router-view>

   

    
    <loading/>
    <out/>
    <mes/>


  </div>
</template>
<script>
import loading from '@/components/common/loading'
import out from '@/components/common/out'
import mes from '@/components/common/mes'




export default {
  name: 'App',
  components:{loading,out,mes}
}
</script>





// WEBPACK FOOTER //
// src/App.vue